import React from 'react';
import { CONFIG } from 'utils/config';
import { usePoorStandingContext } from 'contexts/PoorStandingContext/PoorStandingContext';

interface UsePoorStandingBanner {
    isPoorStandingVisible: boolean;
    goToAccountBilling: () => void;
    handleDismiss: (e: React.MouseEvent) => void;
}

export const usePoorStandingBanner = (): UsePoorStandingBanner => {
    const { isPoorStandingVisible, showPoorStanding } =
        usePoorStandingContext();

    const goToAccountBilling = () => {
        window.open(`${CONFIG.VITE_ACCOUNT_BILLING_URL}`, '_blank');
        showPoorStanding(false);
    };

    const handleDismiss = (e: React.MouseEvent) => {
        e.preventDefault();
        showPoorStanding(false);
    };

    return { isPoorStandingVisible, goToAccountBilling, handleDismiss };
};
